import { atom } from 'jotai';
import { DEFAULT_PAGINATION } from '@/common/pagination/types.ts';

export const projectPaginationAtom = atom(DEFAULT_PAGINATION);

export const resetProjectPaginationOnFilterChangeAtom = atom(null, (_get, set) => {
  set(projectPaginationAtom, DEFAULT_PAGINATION);
});
